// src/data/testimonials.js
// Single source of truth for client testimonials.
// `testimonials` is shared by the Architectural Design and Residential Design pages.
// `interiorTestimonials` is used by the Interior Design page.

export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Hotel Owner, Jaipur",
    quote:
      "Arch Point turned our vision into a building we're proud of. Handover slipped by a few weeks, but the quality made up for it.",
    rating: 4.5,
  },
  {
    name: "Priya Sharma",
    role: "Villa Owner, Udaipur",
    quote:
      "Every space reflects precision, aesthetics and function. The 3D walkthroughs made decision-making far easier for us.",
    rating: 5,
  },
  {
    name: "Vikram Singh",
    role: "Property Developer",
    quote:
      "Strong on design and execution. Communication during the early drawing stage could have been quicker, but the outcome was worth it.",
    rating: 4,
  },
];

export const interiorTestimonials = [
  {
    name: "Bhagwati Sharma",
    role: "Homeowner",
    quote:
      "Arch Point transformed our home into a masterpiece. Every corner reflects our personality while staying practical to live in.",
    rating: 5,
  },
  {
    name: "Gaurav Sharma",
    role: "Apartment Owner",
    quote:
      "The team understood our vision quickly and the finish is excellent. A couple of material substitutions took longer than planned.",
    rating: 4.5,
  },
  {
    name: "Vivek Kalra",
    role: "Residence Owner",
    quote:
      "Great attention to detail and smart storage solutions throughout. Worth the wait for the custom joinery.",
    rating: 4,
  },
];

export default testimonials;